Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STYLES = void 0;
var _FontSize = require("./FontSize");
var _Grid = require("./Grid");
var _useStyles = require("./useStyles");
var STYLES = exports.STYLES = {
  fontSize: _FontSize.fontSize,
  grid: _Grid.grid,
  lineHeight: _FontSize.lineHeight,
  useStyles: _useStyles.useStyles
};